import React from 'react'
import { withIcon } from '../../withIcon'

function SpeakerMinIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M15.2485 5.62229L11.9586 8.77548H8.81685C8.60021 8.77548 8.39244 8.87167 8.23925 9.04288C8.08606 9.2141 8 9.44632 8 9.68845V14.3937C8 14.6358 8.08606 14.8681 8.23925 15.0393C8.39244 15.2105 8.60021 15.3067 8.81685 15.3067H12.0444L15.2485 18.3777C15.3146 18.4409 15.3955 18.4817 15.4817 18.4951C15.5678 18.5086 15.6556 18.4941 15.7347 18.4536C15.8137 18.413 15.8807 18.3479 15.9277 18.2661C15.9748 18.1843 15.9998 18.0892 16 17.992V6.00916C16 5.91184 15.9751 5.81654 15.9281 5.73457C15.8812 5.6526 15.8142 5.5874 15.7351 5.54668C15.656 5.50597 15.5682 5.49145 15.4819 5.50485C15.3957 5.51825 15.3147 5.559 15.2485 5.62229Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SpeakerMinIcon)
